import BaseSettingsPage from "@settings/base/BaseSettingsPage";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { notificationSlice } from "@store/slices/notification";

export const TestSettingsPage = () => {
  const dispatch = useDispatch();

  const triggerNotification = (type: 'info' | 'success' | 'warning' | 'error') => {
    dispatch(notificationSlice.actions.triggerNotification({
      title: `${type.charAt(0).toUpperCase() + type.slice(1)} Notification`,
      content: `Das ist eine "${type}" Notification`,
      type,
      autoHideDuration: 5000
    }));
  };

  return <BaseSettingsPage title="Test Settings">
    <Divider sx={{ my: 2 }} />
    <Typography variant="h6">Test Notifications</Typography>
    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
      <Button 
        variant="contained" 
        color="info" 
        onClick={() => triggerNotification('info')}
      >
        Info
      </Button>
      <Button 
        variant="contained" 
        color="success" 
        onClick={() => triggerNotification('success')}
      >
        Success
      </Button>
      <Button 
        variant="contained" 
        color="warning" 
        onClick={() => triggerNotification('warning')}
      >
        Warning
      </Button>
      <Button 
        variant="contained" 
        color="error" 
        onClick={() => triggerNotification('error')}
      >
        Error
      </Button>
    </Box>
    <Divider sx={{ my: 2 }} />
  </BaseSettingsPage>
}